import React from "react";
import { AriaButtonProps } from "react-aria";

import { _Button, ButtonProps } from "./_Button";

type Props = AriaButtonProps &
  Pick<ButtonProps, "leftIcon" | "size" | "fullWidth" | "isLoading" | "testID">;

export function DangerButton(props: Props) {
  const { testID = "danger-button" } = props;

  return (
    <_Button
      color="text-inverse"
      fill="background-danger-strong"
      focusStyle="focus-action"
      hoverFill="background-danger-strong-hover"
      shadow="shadow-button"
      testID={testID}
      {...props}
    />
  );
}
